import {useEffect, useRef, useState} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useLocation} from 'react-router-dom';
import DotsLoading from '../../../components/dotsLoading';
import {ISendMessagePayload} from '../../../models/payload/sendMessagePayload';
import {ChatType} from '../../../models/utilities/chatType';
import MessageFooter from '../../../module/message/footer';
import MessageHeader from '../../../module/message/header';
import PortalFooter from '../../../module/message/portalFooter';
import RoomMessages from '../../../module/message/room';
import UseGetRoom from '../hooks/useGetRoom';
import useSendMessage from '../hooks/useSendMessage';
import CustomDrawer from '../../../components/customDrawer';
import ViolationModal from '../../../module/violationModal';
import {ViolationMessages} from '../../../module/message/header/constant';

const MessageRoom = () => {
  const {state} = useLocation();
  const {messages, refetch, fetchNextPage} = UseGetRoom(state?.id);
  const [message, setMessage] = useState<string>('');
  const [openViolationModal, setOpenViolationModal] = useState<boolean>(false);
  const {isLoading, mutate} = useSendMessage(setMessage, refetch);
  const sendMessage = () => {
    const payload: ISendMessagePayload = {
      chat_guid: state.id,
      first_app: ChatType.SUPPLIER,
      second_app: ChatType.FARM,
      text: message,
    };
    mutate(payload);
  };

  const messagesEndRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView();
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <>
      <div className="row fixed-top">
        <MessageHeader
          title={state?.title}
          setOpenViolationModal={setOpenViolationModal}
        />
      </div>
      <div>
        <div
          id="scrollableDiv"
          style={{
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column-reverse',
            height: '100vh',
            paddingBottom: '70px',
            marginBottom: '70px',
            paddingTop: '50px',
          }}
        >
          {messages && (
            <InfiniteScroll
              dataLength={messages?.pages.flatMap(x => x.results).length || 0}
              next={() => {
                fetchNextPage();
              }}
              style={{display: 'flex', flexDirection: 'column-reverse'}}
              inverse={true}
              hasMore={!!messages?.pages[messages?.pages.length - 1].next}
              pullDownToRefreshThreshold={50}
              loader={
                <div className="my-3">
                  <DotsLoading />
                </div>
              }
              scrollableTarget="scrollableDiv"
            >
              <div className="mt-3">
                <RoomMessages
                  messages={messages?.pages.flatMap(x => x.results) || []}
                />
                <div ref={messagesEndRef}></div>
              </div>
            </InfiniteScroll>
          )}
        </div>
      </div>
      <PortalFooter>
        <MessageFooter
          message={message}
          setMessage={setMessage}
          sendMessage={sendMessage}
          isLoading={isLoading}
        />
      </PortalFooter>
      <CustomDrawer
        anchor="bottom"
        isOpen={openViolationModal}
        onDismiss={() => setOpenViolationModal(false)}
      >
        <ViolationModal
          open={openViolationModal}
          handleClose={() => setOpenViolationModal(false)}
          items={ViolationMessages}
          guid={state.id}
          object_type="chat"
        />
      </CustomDrawer>
    </>
  );
};

export default MessageRoom;
